import { render } from "./B2bPageBorrador.vue?vue&type=template&id=7b2b58bb&scoped=true&lang=pug"
import script from "./B2bPageBorrador.vue?vue&type=script&lang=js"
export * from "./B2bPageBorrador.vue?vue&type=script&lang=js"

import "./B2bPageBorrador.vue?vue&type=style&index=0&id=7b2b58bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2b58bb"]])

export default __exports__